import { apiClient } from './client';
import type { TaskTemplate, ApplyTaskTemplateDto } from '@/types/taskTemplate.types';
import type { Task } from '@/types/task.types';

class TaskTemplateService {
  /**
   * List all system templates, optionally filtered by search text.
   */
  async getAll(search?: string): Promise<TaskTemplate[]> {
    const params = new URLSearchParams();
    if (search?.trim()) params.set('search', search.trim());
    const qs = params.toString();
    const response = await apiClient.get(`/task-templates${qs ? `?${qs}` : ''}`);
    return response.data.data || [];
  }

  /**
   * Get ranked template suggestions for a celebration, ordered by tag overlap.
   */
  async getSuggestions(celebrationId: number): Promise<TaskTemplate[]> {
    const response = await apiClient.get(`/task-templates/suggestions?celebrationId=${celebrationId}`);
    return response.data.data || [];
  }

  /**
   * Instantiate a real Task from a template.
   */
  async apply(templateId: number, dto: ApplyTaskTemplateDto): Promise<Task> {
    const response = await apiClient.post(`/task-templates/${templateId}/apply`, dto);
    return response.data.data;
  }
}

export const taskTemplateService = new TaskTemplateService();
